import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "highlight",
  pure: true,
})
export class HighlightPipe implements PipeTransform {
  transform(itemName: string, query: string | null | undefined): string {
    if (!query) {
      return itemName;
    }

    const regExp = new RegExp(query, "gi");

    return itemName.replace(regExp, "<mark>$&</mark>");
  }
}
